import { IonContent, IonFab, IonFabButton, IonIcon, IonPage, useIonToast } from '@ionic/react';
import { addCircleOutline, chatboxOutline, chatbubbleOutline, mailOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { Modal } from 'react-responsive-modal';

import ActionButton from '../../../../components/button/ActionButton';
import InputItem from '../../../../components/input/InputItem';
import ListItem from '../../../../components/list/ListItem';
import LoadingContainer from '../../../../components/loading/LoadingContainer';
import { Empty } from '../../../../layouts/errors/Empty';
import LayoutGap from '../../../../layouts/LayoutGap';
import Toolbar from '../../../../layouts/Toolbar';
import { DataProvider } from '../../../../library/DataProvider';
import { MessageListGetAction, SubmitMessagePostAction } from '../../../../redux/actions/Account';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';

import './MessageList.css';
import 'react-responsive-modal/styles.css';

const MessageList: React.FC = () => {
    const [toast, dismiss] = useIonToast();

    const dispatch = useAppDispatch()

    let formPostMessage = useAppSelector(state => state.submitMessageReducer)
    const { form_loading, resp } = formPostMessage

    const { loading, messages } = useAppSelector(state => state.messageListReducer)
    // const [showAddMessageModal, setShowAddMessageModal] = useState(false);

    const [showAddMessageModal, setShowAddMessageModal] = useState(false);

    const [form, setForm] = useState({
        subject: { value: "", validation: { required: true }, error: "" },
        message: { value: "", validation: { required: true }, error: "" }
    });

    const [formProvider] = useState(() => new DataProvider(form, setForm));

    const formSubmitHandler = (e: any) => {
        e.preventDefault();

        let formValidation = formProvider.validation(form);

        if (formValidation) {
            dispatch(SubmitMessagePostAction("0", form.subject.value, form.message.value))
        }
    }

    useEffect(() => {
        dispatch(MessageListGetAction())
    }, [dispatch])

    useEffect(() => {
        const formDone = () => {
            if (resp != null && !form_loading) {
                if (resp.result) {
                    toast({ message: resp.message, duration: 2000, color: "primary" })

                    formProvider.reset();

                    dispatch(MessageListGetAction())
                } else {
                    toast({ message: resp.message, duration: 2000, color: "danger" })
                }
            }
        }

        formDone();
    }, [form_loading])

    const showCommentHandler = () => {
        setShowAddMessageModal(true);
    }

    const hideCommentHandler = () => {
        setShowAddMessageModal(false);
    }

    return <LoadingContainer loading={loading}>
        <IonPage>
            <Toolbar title="پیام ها" hasBackButton />

            <LayoutGap />

            <IonContent className="order-list main-content">
                <Empty text="پیامی ثبت نشده است!" icon={chatbubbleOutline} length={messages.tickets?.length}>
                    {messages.tickets?.map((item: any) => {
                        let color = "";

                        switch (item.status) {
                            case 0: color = "info"; break;
                            case 1: color = item.user_seen == 0 ? "warning" : "success"; break;
                            case 2: color = "danger"; break;
                        }

                        return <ListItem key={`message-item-${item.id}`} title={item.subject} status={item.status_title} date={item.date} dateTitle="تاریخ ارسال پیام" color={color} link={`/account/messages/${item.id}`} />
                    })}
                </Empty>
            </IonContent>

            <IonFab vertical="bottom" horizontal="end">
                <IonFabButton onClick={showCommentHandler}><IonIcon icon={addCircleOutline} /></IonFabButton>
            </IonFab>

            <Modal open={showAddMessageModal} onClose={hideCommentHandler} center showCloseIcon={false}>
                <form onSubmit={formSubmitHandler}>
                    <InputItem name="subject" type="text" label="موضوع" icon={mailOutline} maxlength={50} provider={formProvider} />

                    <InputItem name="message" type="textarea" label="پیام شما" icon={chatboxOutline} maxlength={1000} rows={3} provider={formProvider} />

                    <ActionButton text="ارسال پیام" loading={form_loading} />
                </form>
            </Modal>

            {/* <IonModal
                cssClass="add-message-modal"
                isOpen={showAddMessageModal}
                swipeToClose={true}
                onDidDismiss={hideCommentHandler}>


            </IonModal> */}
        </IonPage>
    </LoadingContainer>
}

export default MessageList